import { render } from "./LoginForm2.vue?vue&type=template&id=352d3230&scoped=true"
import script from "./LoginForm2.vue?vue&type=script&lang=js"
export * from "./LoginForm2.vue?vue&type=script&lang=js"

import "./LoginForm2.vue?vue&type=style&index=0&id=352d3230&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352d3230"]])

export default __exports__